import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Takes the visitor to the homepage's Send a message form: a smooth scroll
  // when already on the homepage, otherwise back to the homepage, which
  // scrolls to the form when it sees the #contact-form hash.
  const handleContact = () => {
    if (location.pathname === '/') {
      document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/#contact-form');
    }
  };

  return (
    <footer className="bg-background border-t border-gray-light py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-tertiary">&copy; {new Date().getFullYear()} Kacey Fillingim. All rights reserved.</p>
          </div>
          <div className="flex space-x-6">
            <button
              onClick={handleContact}
              className="text-tertiary hover:text-secondary transition-colors duration-300"
            >
              Contact
            </button>
            <a href="https://www.linkedin.com/in/kaceyfillingim/" target="_blank" rel="noopener noreferrer" className="text-tertiary hover:text-secondary transition-colors duration-300">
              LinkedIn
            </a>
            <a href="https://kaceyaf.com" target="_blank" rel="noopener noreferrer" className="text-tertiary hover:text-secondary transition-colors duration-300">
              KaceyAF.com
            </a>
            {/* <button
              onClick={(e) => {
                e.preventDefault();
                window.location.href = 'mailto:kfilli20@gmail.com';
              }}
              className="text-tertiary hover:text-secondary transition-colors duration-300"
            >
              Email
            </button> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;